import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useTechnologicalTransferEdit } from '@/module/Author/TechnologicalTransfer/model/TechnologicalTransferQuery';
import {
  TechnologicalTransferSchema,
  defaultTechnologicalTransferValues,
  technologicalTransferSchema,
} from '@/module/Author/TechnologicalTransfer/model/TechnologicalTransferSchema';

import { useAppNotification } from '@feature/utils';

import { TechnologicalTransferForm } from './TechnologicalTransferForm';
import { TechnologicalTransfer } from './model/TechnologicalTransferTypes';

interface TechnologicalTransferEditProps {
  technologicalTransfer: TechnologicalTransfer;
}

const convert = (technologicalTransfer: TechnologicalTransfer): TechnologicalTransferSchema => ({
  ...technologicalTransfer,
});

export function TechnologicalTransferEdit(props: TechnologicalTransferEditProps) {
  const { technologicalTransfer } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useTechnologicalTransferEdit(technologicalTransfer.id);

  const notification = useAppNotification();
  const onSubmit = (values: TechnologicalTransferSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(technologicalTransfer), [technologicalTransfer]);
  const navigate = useNavigate();

  return (
    <TechnologicalTransferForm
      title={t('technologicalTransfers.form.title.edit')}
      schema={technologicalTransferSchema}
      defaultValues={defaultTechnologicalTransferValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
